module.exports = __webpack_public_path__ + "media/images/firsttime_header01_pc-0d9ccc575b720d82c5838ec18bc18b68.png";